module.exports = {"data":{"site":{"siteMetadata":{"title":"Jorge Mancheno, Product Designer"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 378
// module chunks = 273950069227526